const tabNavItems = document.querySelectorAll('.tab-nav__item > a');
const accordionItems = document.querySelectorAll('.accordion__item');
let lastType = null;

tabNavItems.forEach((contactLink) =>
  contactLink.addEventListener('click', (e) => {
    const key = e.target.getAttribute('data-key');

    if (window.dataLayer && key != lastType) {
      window.dataLayer.push({
        'event': 'event',
        'eventCategory': 'Sales Portal',
        'eventAction': 'FAQs - ' + key,
        'eventLabel': 'Selected',
        'eventNonInteraction': false
      });
    }

    setFaqType(key != lastType ? key : null);
  })
);

function setFaqType(type) {
  lastType = type;

  accordionItems.forEach((item) => {
    const typesRaw = item.getAttribute('data-types');
    if (typesRaw) {
      const types = typesRaw.split(',');
      if (!!type && !types.includes(type)) {
        item.classList.add('is-hidden');
      } else {
        item.classList.remove('is-hidden');
      }
    }
  });

  tabNavItems.forEach((item) => {
    const key = item.getAttribute('data-key');
    if (!!type && type == key) {
      item.classList.add('is-active');
    } else {
      item.classList.remove('is-active');
    }
  });
}

if (location.hash) {
  setFaqType(location.hash.replace('#', ''));
}
